// extracted by mini-css-extract-plugin
export default {"submitButton":"validateEmail_submitButton__ZlEmh","headerText":"validateEmail_headerText__kpMIg","or":"validateEmail_or__StNjB","resetLink":"validateEmail_resetLink__Yljpe"};